var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',[_c('page-header'),_c('div',{staticClass:"container-div"},[_c('router-view')],1)],1),_c('Snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }